module.exports = "../../../../platform/assets/pageMainIcon/ig-business-setting-7.svg";